import { useCurrentRouteConfig } from 'src/app/routes';

export function useCurrentLocationIgnoredByCookieWall(): boolean {
	const routeConfig = useCurrentRouteConfig();
	return !!routeConfig?.config.preventCookieWall;
}
